/* eslint-disable */
/*! Copyright (c) 2016 Naufal Rabbani (http://github.com/BosNaufal)
* Licensed Under MIT (http://opensource.org/licenses/MIT)
*
* React File Base64 - Version@1.0.0
*
*/

import React from 'react';
import './filebase64.css';

import convertFile from './convertFile';
import compressFile from './compressFiles';

import pickType from './utils/pickType';

export default class FileBase64 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
      title: null,
    };
  }

  async handleChange(e) {
    const files = [...e.target.files];

    const finishFiles = [];

    for (const file of files) {
      if (file.type.substring(0, 5) === 'image') {
        const fileData = await compressFile(file);
        const fileCompress = {
          name: file.name,
          type: file.type,
          size: file.size,
          base64: fileData[0].data,
        };
        finishFiles.push(fileCompress);
      } else {
        const typeFile = pickType(file.name);

        const base64Data = await convertFile(file);

        const fileConvert = {
          name: file.name,
          ext: typeFile.ext,
          type: typeFile.mimetype,
          size: file.size,
          base64: base64Data.replace(/.*;\w*base64,/, ''),
        };
        finishFiles.push(fileConvert);
      }
    }

    if (finishFiles.length === files.length) {
      if (this.props.multiple) {
        await this.setState({ title: `${finishFiles.length} arquivos selecionados` });
        return this.props.onDone(finishFiles);
      }
      if (parseInt(((finishFiles[0].size / 1024) / 1024), 10) > 20) {
        console.log('passou aqui');
        return false;
      }

      await this.setState({ title: finishFiles[0].name });
      return this.props.onDone(finishFiles[0]);
    }
  }


  render() {
    return (
      <div className="filebaseDiv">
        <input
          type="file"
          accept="image/jpeg, image/png, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/msword, application/excel,"
          name="filebase64"
          id="filebaseInput"
          onChange={this.handleChange.bind(this)}
          multiple
        />
        <label className="btn btn-success" id="filebaseLabel2" htmlFor="filebaseInput">{(this.state.title || this.props.title)}</label>
        {
          this.props.formatos
            ? (
              <small className="filebaseSmall">
                Formatos válidos:
                {' '}
                {this.props.formatos}
              </small>
            )
            : ''
          }
      </div>
    );
  }
}

FileBase64.defaultProps = {
  multiple: false,
};
